/**
 * @file CPCooperationCase 首页 视频列表
 * @author FengGuang(fengguang01@baidu.com)
 */

import { useCallback, useRef } from 'react';
import { Col } from 'antd';
import VideoCover from './video-cover/VideoCover';
import VideoModal from './video-modal/VideoModal';
import './style.less';


const VideoListItem = (props: any) => {
    const videoCoverRef = useRef<HTMLVideoElement>(null);
    // const [maskStatus, setMaskStatus] = useState<boolean>(false);
    const onMouseEnter = useCallback(() => {
        if (videoCoverRef.current) {
            // setMaskStatus(true);
            // videoCoverRef.current.play();
        }
    }, []);
    const onMouseLeave = useCallback(() => {
        if (videoCoverRef.current) {

            videoCoverRef.current.pause();
            // setMaskStatus(false);
        }
    }, []);
    const renderContext = () => (
        <Col xs={6}>
            <div
                className="CPCooperationCase-index-video-list-item"
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                <div
                    className="CPCooperationCase-index-video-list-item-background"
                    style={{
                        backgroundImage: props.backgroundImage ? `url(${props.backgroundImage})` : undefined
                    }}
                >
                    {!!props.backgroundVideo
                        && (
                            <VideoCover
                                ref={videoCoverRef}
                                src={props.backgroundVideo}
                                height={360}
                                width={680}
                                loop
                            />
                        )}
                    <div className="CPCooperationCase-index-video-list-item-background-mask" />
                </div>
                {/* {
                    maskStatus === false ?
                        //   {/* 文案信息 */}
                {/* <div className="CPCooperationCase_wraaper">
                            <div className="CPCooperationCase_mask">
                                <div className="CPCooperationCase_mask_text" style={{ background: `url(${props.backImg})` }}>
                                    <div className="CPCooperationCase_mask_text-screen">
                                        <div className="CPCooperationCase_mask_text_icon"></div>
                                    </div>

                                </div>
                            </div>
                        </div> */}
                {/* : */}
                {/* null */}
                {/* } */}

                {/* 文案信息 */}
                <div className="CPCooperationCase_wraaper">
                    <div className="CPCooperationCase_mask">
                        <div className="CPCooperationCase_mask_text" style={{ background: `url(${props.backImg})` }}>
                            <div className="CPCooperationCase_mask_text-screen">
                                <div className="CPCooperationCase_mask_text_icon"></div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </Col>
    );
    return (
        <VideoModal src={props.link}>
            {renderContext()}
        </VideoModal>
    );
};

export default VideoListItem;
